'use client'

import { useEffect, useState } from 'react'

import { Icon, IconComponent } from '@graftcode/design-system'

import { SCROLL_TO_TOP_BUTTON_TEST_IDS } from '@/shared/docs-test-ids.const'
import { scrollWindowToTopSmooth } from '@/shared/utils/scrollWindowToTopSmooth'

import styles from './ScrollToTopButton.module.scss'

export function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down
      if (window.scrollY > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)

    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  if (!isVisible) {
    return null
  }

  return (
    <button
      data-testid={SCROLL_TO_TOP_BUTTON_TEST_IDS.root}
      className={styles.scrollToTopButton}
      onClick={scrollWindowToTopSmooth}
      aria-label="Scroll to top"
      type="button"
    >
      <IconComponent icon={Icon.ArrowUpRegular} size={20} className={styles.icon} />
    </button>
  )
}
